/**
 * API base URL (no trailing slash).
 * - Development: http://localhost:4001
 * - Production: https://api.kimnmatt.com
 * Override with REACT_APP_API_BASE_URL in .env
 */
export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv && fromEnv !== "mock") {
    return fromEnv.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    // Same-origin via package.json `proxy` so session cookies work over HTTP in dev.
    return "";
  }
  return "https://api.kimnmatt.com";
}
